import React, { useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import {
  Container,
  Box,
  Divider,
  CardContent,
  Button,
  Typography,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import LogoExtended from '../../assets/extendedLogo.svg';
import MainLogos from '../../assets/main-logos.svg';
import ShowSnackbar, { SetSnackbarType } from '../../components/SnackBar';
import api from '../../services/api';
import { optionStyles } from './styles';

interface FormData {
  usarname: string;
  password: string;
}

interface User {
  groups: string[];
}

const Login: React.FC = () => {
  const [err, setErr] = useState<boolean>(false);
  const [name, setName] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [showPassoword, setShowPassword] = useState<boolean>(true);
  const history = useHistory();
  const [snackBar, setSnackbar] = useState<SetSnackbarType>({ open: false, message: '' });
  const classes = optionStyles();
  const formRef = useRef<FormHandles>(null);

  const handleSubmit = async (data = { username: name, password }) => {
    const authData = await api.post('/api-token-auth/', data).catch(() => {
      setSnackbar({
        open: true,
        message: 'Usuário ou senha incorretos!',
      });
      setErr(true);
    });
    if (authData) {
      api
        .get<User>(`/api/users/${authData.data.user}/`, {
          headers: { Authorization: `Token ${authData.data.token}` },
        })
        .then((user) => {
          const groups = user.data.groups.join(' ');
          localStorage.setItem('groups', groups);
          localStorage.setItem('auth', authData.data.token);
          localStorage.setItem('id', authData.data.user);
          history.push('/');
          window.location.reload();
        })
        .catch(() => {
          return setErr(true);
        });
    }
  };

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassoword);
  };

  return (
    <Container maxWidth="xl" className={classes.rootContainer}>
      <Box className={classes.rootCard}>
        <CardContent className={classes.cardContent}>
          <img src={LogoExtended} alt="Logo VIDA" width="200" className={classes.logo} />
          <Divider className={classes.divider} orientation="horizontal" />
          <Typography variant="h6" style={{ color: '#404040', marginBottom: '5%' }}>
            Entrar
          </Typography>

          <Form className={classes.rootForm} ref={formRef} onSubmit={handleSubmit}>
            {err && (
              <Typography
                variant="subtitle2"
                style={{ color: '#90002B', marginBottom: '5%' }}
              >
                Usuário ou senha incorretos. Tente novamente
              </Typography>
            )}
            <FormControl variant="outlined">
              <InputLabel htmlFor="username">Nome de usuário</InputLabel>
              <OutlinedInput
                id="username"
                name="username"
                label="Nome de usuario"
                type="text"
                required
                placeholder="Nome de usuário"
                className={classes.input}
                value={name}
                onChange={handleNameChange}
              />
            </FormControl>
            <FormControl variant="outlined">
              <InputLabel htmlFor="password"> Senha</InputLabel>
              <OutlinedInput
                id="password"
                name="password"
                label="Senha:"
                type={showPassoword? 'password': 'text'}
                required
                placeholder="Sua senha de acesso"
                className={classes.input}
                value={password}
                onChange={handlePasswordChange}
                endAdornment={(
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleShowPassword}
                      onMouseDown={handleShowPassword}
                    >
                      {showPassoword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                )}
              />
            </FormControl>
            <Button
              variant="outlined"
              className={classes.rootButton}
              onClick={() => handleSubmit()}
            >
              Login
            </Button>
          </Form>
          <div className={classes.linksContainer}>
            <Link className={classes.link} to="/registrar">
              Criar uma nova conta
            </Link>
            <Link className={classes.link} to="/recuperarsenha">
              Esqueceu a senha?
            </Link>
          </div>
        </CardContent>
        <img src={MainLogos} alt="Logo VIDA" className={classes.mainLogos} />
      </Box>

      <ShowSnackbar
        open={snackBar.open}
        message={snackBar.message}
        setSnackbar={setSnackbar}
      />
    </Container>
  );
};

export default Login;
